import "mapbox-gl/dist/mapbox-gl.css";

const MapboxConfig = {
  accessToken:
    "pk.eyJ1IjoiZW9tYXAiLCJhIjoiY2tkZnhvaDJiMjAzeTM2bWh3cHlpN3o0NyJ9.f24MRfc5um4GmKiQC5bCoQ",
  style: "mapbox://styles/mapbox/streets-v8"
};

export default MapboxConfig;
